import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

// src/client.ts
var clientSchema = {
  VITE_API_URL: z.url().optional(),
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  // VAPID public key for Web Push subscription (safe for the browser). Optional
  // so the web app boots without push configured; the opt-in UI hides when missing.
  VITE_VAPID_PUBLIC_KEY: z.string().optional(),
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.url().optional().default("https://us.i.posthog.com"),
  VITE_POSTHOG_DEV_ENABLED: z.string().optional().transform((val) => val === "true" || val === "1"),
  // Stripe publishable key (safe for the browser; identifies the Stripe
  // account when redirecting to hosted Checkout). Optional so the web app
  // boots without billing configured; billing UI hides itself when missing.
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().startsWith("pk_").optional(),
  // Existing dev-skip toggle for the upgrade flow. Kept so devs can bypass
  // the real Stripe redirect during local development.
  VITE_STRIPE_DEV_SKIP: z.string().optional().transform((val) => val === "true" || val === "1"),
  // Mapbox public token (pk.*) for the operator pricing-zones map.
  // Safe for the browser; used only for map rendering, not geocoding.
  VITE_MAPBOX_TOKEN: z.string().optional()
};

// src/client.ts
function getRuntimeEnv() {
  if (typeof window !== "undefined" && typeof import.meta !== "undefined") {
    return import.meta.env;
  }
  return process.env;
}
function shouldSkipValidation() {
  if (typeof window !== "undefined") {
    return false;
  }
  return process.env["SKIP_ENV_VALIDATION"] === "true";
}
var env = createEnv({
  clientPrefix: "VITE_",
  client: clientSchema,
  /**
   * Runtime environment source - supports both browser and Node.js contexts.
   */
  runtimeEnv: getRuntimeEnv(),
  /**
   * Treat empty strings as undefined to apply defaults correctly.
   */
  emptyStringAsUndefined: true,
  /**
   * Skip validation during builds when env vars may not be available.
   */
  skipValidation: shouldSkipValidation()
});

export { env };
//# sourceMappingURL=client.js.map
//# sourceMappingURL=client.js.map